import "./StickyHeader.scss";
import { useState, useEffect } from "react";
import Button from "./Button";

function Header() {
	const [isScrolled, setIsScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			setIsScrolled(scrollPosition > 100); // Change navigation content after scrolling more than 100px
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<>
			<nav className={`sticky-nav ${isScrolled ? "scrolled" : ""}`}>
				{!isScrolled ? (
					<div className="nav-content-before">
						<div className="logo-text-container">
							<p className="logo-text">BMW WESTERN REGION</p>
							<p className="logo-text">
								2026 TIER 3 DIGITAL PROGRAMS
							</p>
						</div>
						<img
							src={require("../../assets/bmwLogo_white.webp")}
							alt="BMW Logo"
							className="bmw-logo"
						/>
					</div>
				) : (
					<div className="nav-content-after">
						<div className="logo-container">
							<img
								src={require("../../assets/bmwLogo_grey.png")}
								alt="BMW Logo"
								className="bmw-logo"
							/>
							<div className="logo-text-container">
								<p className="logo-text">BMW WESTERN REGION</p>
								<p className="logo-text">
									2026 TIER 3 DIGITAL PROGRAMS
								</p>
							</div>
						</div>
						<Button link="/enroll" styleName="Blue" size="xsmall">
							Enroll Now
						</Button>
					</div>
				)}
			</nav>
		</>
	);
}

export default Header;
